export enum ProsecutionRecommendation {
	DisciplinaryLawsuit = 1,
	PublicProsecutionReferral = 2,
	Archive = 3,
}
